<div class="flex-container gap-4" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.quantite_produite_periode' | trans" [widget]="widget()" [draggable]="true" [filter]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
    @if (ligneElements().length > 1) {
      <vl-select-autocomplete class="filter ligne-select"
        [options]="ligneElements()"
        [value]="selectedLigne()"
        [selectLabel]="'dashboard_ui.toutes_lignes' | trans"
        [minWidth]="false"
        [showSubscript]="false"
        (valueChange)="onLigneChange($event)"/>
    }
    <vl-widget-period-filters class="filter" [(period)]="period" [(timeScale)]="timeScale" [(comparison)]="comparison"/>
  </vl-widget-title>

  @if (metadata()?.loading) {
    <div class="overflow-hidden chart-area">
      <div class="flex-row gap-32 align-end">
        <ngx-skeleton-loader count="1" [theme]="{'height': '200px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '140px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '220px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '110px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '90px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
        <ngx-skeleton-loader count="1" [theme]="{'height': '30px', 'width': '70px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else if (data()?.data?.length) {
    <div class="chart-area fade-in">
      <canvas class="w100 h100" #qteProduite></canvas>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
